module.exports = __webpack_public_path__ + "static/media/settings.0a0fe738.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/black/settings.svg
// module id = 1345
// module chunks = 0